import { createLazyComponent } from '../shared/createLazyComponent';

// rethrowOnError: see .claude/context/code-splitting.md ("No placeholder is needed...").
export const LazyAssistantDataProvider = createLazyComponent(
  () => import('./AssistantDataProvider'),
  'AssistantDataProvider',
  { label: 'Assistant Data Provider', rethrowOnError: true },
);
